import React from 'react';

import {
  EmailTemplateHtmlPreviewType,
  useCreateLayoutTemplateMutation,
  useCreateTemplateFromSampleMutation,
  useSampleWaypointLayoutsQuery,
} from '@dashboard/generated/wp/platform';
import { useShowTemplateNavigate } from '@dashboard/hooks/navigate/usePlatformNavigator';
import { Box } from '@mui/material';

import SampleTemplateCard from './SampleTemplateCard';

type Props = {
  close: () => void;
};
export default function LayoutBody({ close }: Props) {
  const { data } = useSampleWaypointLayoutsQuery();
  const [createEmpty, { loading: loadingEmpty }] = useCreateLayoutTemplateMutation();
  const [createTemplateFromSample, { loading: loadingSample }] = useCreateTemplateFromSampleMutation();
  const showTemplate = useShowTemplateNavigate();

  const onCreateEmptyTemplate = async () => {
    const { data } = await createEmpty();
    close();
    const id = data?.createTemplate.id;
    if (id) {
      showTemplate(id);
    }
  };

  const onCreateSampleTemplate = async (sampleTemplateId: string | null) => {
    if (!sampleTemplateId) {
      return;
    }
    const { data } = await createTemplateFromSample({ variables: { sampleTemplateId } });
    close();
    const id = data?.createTemplateFromSample.id;
    if (id) {
      showTemplate(id);
    }
  };

  const nodes = data?.SampleWaypointTemplates.nodes ?? [];
  const loadingMutation = loadingEmpty || loadingSample;
  return (
    <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={2} py={3}>
      <SampleTemplateCard
        onClick={onCreateEmptyTemplate}
        title="Blank layout"
        disabled={loadingMutation}
        templateId={null}
        templateType={EmailTemplateHtmlPreviewType.Template}
      />
      {nodes.map((n, i) => (
        <SampleTemplateCard
          key={i}
          title={n.name}
          templateId={n.id}
          templateType={EmailTemplateHtmlPreviewType.Sample}
          onClick={onCreateSampleTemplate}
          disabled={loadingMutation}
        />
      ))}
    </Box>
  );
}
